// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_hk-a";
export var fulfillmentFormRail = "_hk-9";
export var headerTitleRow = "_hk-c";
export var orderDetailsWrapper = "_hk-7";
export var orderLinkTrigger = "_hk-2";
export var paymentInformationGrid = "_hk-h";
export var paymentSummaryColumn = "_hk-i";
export var shipmentContainer = "_hk-b";
export var shipmentDetailsMainPane = "_hk-8";
export var shipmentNavigationCard = "_hk-5";
export var shipmentNavigationRail = "_hk-3";
export var shipmentNavigationRailHeader = "_hk-4";
export var shipmentSummaryFact = "_hk-e";
export var shipmentSummaryGrid = "_hk-d";
export var shipmentSummaryMetadataRow = "_hk-f";
export var shipmentSummaryTags = "_hk-g";
export var shipmentWorkspace = "_hk-0";
export var shipmentWorkspaceContent = "_hk-6";
export var shipmentWorkspaceHeader = "_hk-1";